import axios from 'axios';
import { API_ROUTES_NELO_MSS } from './constant.mjs';

function sendToNelo(_ref) {
  let {
    resultCode
  } = _ref;
  axios.post(API_ROUTES_NELO_MSS, {
    resultCode
  }).catch(() => {
    // nothing to do
  });
}

export { sendToNelo };
